'use es6';

import { AD_NETWORK_GOOGLE, AD_OBJECT_AD_CAMPAIGN } from 'reference-resolvers/constants/ReferenceObjectTypes';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { ADS_GOOGLE_CAMPAIGNS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchAdsObjectSearchPageForNetwork, createFetchAdsObjectsByIdsForNetwork, fetchAdsObjectsByIdsForNetwork, fetchAdsObjectSearchPageForNetwork } from 'reference-resolvers/api/AdsEntityApi';
export const createAdsGoogleCampaignsReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: ADS_GOOGLE_CAMPAIGNS,
  createFetchByIds: opts => createFetchAdsObjectsByIdsForNetwork(opts)(AD_NETWORK_GOOGLE, AD_OBJECT_AD_CAMPAIGN),
  createFetchSearchPage: opts => createFetchAdsObjectSearchPageForNetwork(opts)(AD_NETWORK_GOOGLE, AD_OBJECT_AD_CAMPAIGN),
  fetchByIds: fetchAdsObjectsByIdsForNetwork(AD_NETWORK_GOOGLE, AD_OBJECT_AD_CAMPAIGN),
  fetchSearchPage: fetchAdsObjectSearchPageForNetwork(AD_NETWORK_GOOGLE, AD_OBJECT_AD_CAMPAIGN)
}, options));
export default createAdsGoogleCampaignsReferenceResolver();